import { isNil } from 'lodash';
import React, { ReactNode } from 'react';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useChannel } from '@shared/util/hooks';

export type CardChannelContextType = MBAPI.ChannelQuery_channel | undefined;

export const CardChannelContext = React.createContext<CardChannelContextType>(undefined);

interface Props {
  channelSlug: string;
  children: ReactNode;
}

export function MBCardChannelProvider({ channelSlug, children }: Props) {
  const channel = useChannel({ channelSlug });
  if (isNil(channel)) {
    return <MBLoadingIndicator fill />;
  }

  return <CardChannelContext.Provider value={channel}>{children}</CardChannelContext.Provider>;
}
